import { Component, input, InputSignal } from '@angular/core';
import { IMenuTab } from '../../../../entities/sidebar/menu-tab.entity';
import { SidebarItemComponent } from '../item/sidebar-item.component';
import { SidebarMenuComponent } from '../menu/sidebar-menu.component';

@Component({
  selector: 'aw-menu-tab',
  templateUrl: './menu-tab.component.html',
  styles: ``,
  imports: [SidebarItemComponent, SidebarMenuComponent],
})
export class MenuTabComponent {
  menuTab: InputSignal<IMenuTab> = input.required<IMenuTab>();
  isExpanded: InputSignal<boolean> = input.required<boolean>();

  protected toggleExpansion(): void {
    if (this.menuTab().collapsible) {
      this.menuTab().expanded = !this.menuTab().expanded;
    }
  }
}
